import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiTomSelect} from "./UiTomSelect";
import {TomOption} from "tom-select/dist/types/types";
import {UiDms} from "../dms/UiDms";
import {UiBuSubjectEditor} from "../dms/UiBuSubjectEditor";

export class UiBuSubjectSelector extends UiTomSelect
{
	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`<div mu-template="item" mu-widget=".">
				<strong mu-bind="name"></strong>
				<em mu-bind="ic"></em>
			</div>
			<div>
				<span class="btn-link btn" mu-id="createNew">Vytvořit nový subjekt</span>
			</div>`
		);
	}

	afterIndex() {
		this.optionLoader = async (query, callback) => {
			const res: TomOption[] = await UiDms.instance.cl.findBuSubjects(query, null);
			callback(res, []);
		}
		this.init();
	}

	createNew_click() {
		const bse = UiDms.instance.openInModal<UiBuSubjectEditor>("UiBuSubjectEditor", "Přidat subjekt");
		bse.savedPromise.then(buSubject => {
			this.muBindData(buSubject);
			bse.muRemoveSelf();
		})
	}
}